webpackJsonp([16],{

/***/ 64:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = function (utils) {
		'use strict';
	
		/**
		 * Anchor scroll
		 * A plugin that animates the scroll of an anchor-link.
		 * @exports anchorScroll
		 */
		var anchorScroll = {
	
			/**
			 * The initialization function for this module.
			 * @param {Object} els - An array of DOM nodes.
			 * @public
			 */
			init: function (els) {
				this._initEvents(els);
			},
	
	
			/**
			 * Init click event.
			 * @param {Object} els - An array of DOM nodes.
			 * @private
			 */
			_initEvents: function (els) {
				utils.forEach(els, function (el) {
					utils.addEventListener(el, 'click', function (event) {
						if (event.preventDefault) { event.preventDefault(); } else { event.returnValue = false; }
	
						var targetId = el.getAttribute('href').split('#')[1],
							target = document.getElementById(targetId),
							scrollY = window.pageYOffset || document.documentElement.scrollTop,
							scrollToY;
	
						if (target !== null) {
							scrollToY = target.getBoundingClientRect().top + scrollY;
							utils.scrollToY(scrollToY, 1500, 'easeInOutQuint');
							setTimeout(function () {
								window.location.hash = '#' + targetId;
							}, 500);
						}
					});
				});
			}
		};
	
	
		return anchorScroll;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ })

});


// WEBPACK FOOTER //
// partial.16.js